import React from 'react';

interface TextCellProps {
    value: React.ReactNode;
}

const TextCell = ({ value }: TextCellProps) => {
    return <p className="text-foreground overflow-hidden text-sm text-ellipsis">{value}</p>;
};

export default TextCell;
